module.exports = __webpack_public_path__ + "media/images/blog-article-banner-2d813019fbae695ccb06481d30cdafef.png";